export function buildStoppedTreatmentUpdate(
    treatment: Record<string, unknown>,
    stopMotive: string,
): Record<string, unknown> {
    return {
        ...treatment,
        'treatment-stop_motive': stopMotive,
        // ISO matches backend stopTreatment() and epochOrIsoToDate() on reload.
        'treatment-stoppedAt': new Date().toISOString(),
    };
}
